/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-28T09:56:25.431Z by lizhutang (lizhutang@spolo.org)

'use strict'

function changeFitToDefault ($ele) {
  let fitTo = $ele.attr('lj-fit-to') || $ele.attr('data-lj-fit-to')
  if (!fitTo) {
    $ele.attr('lj-fit-to', 'fixed')
  }
}

function ProcElement ($content, buildInfo) {
  if ($content && $content.find('[lj-type]').length > 0) {
    buildInfo.prejs = buildInfo.prejs || []
    buildInfo.precss = buildInfo.precss || []
    let libSite = buildInfo.libsite || 'libs.wware.org'
    buildInfo.precss.push(`//${libSite}/layerjs/0.6.2/layerjs-0.6.2.css`)
    buildInfo.prejs.push(`//${libSite}/layerjs/0.6.2/layerjs-0.6.2.min.js`)
    // @TODO: 这里寻找lj-type=layer的所有元素。并为其添加父元素<div id='self' style="position:absolute;margin:0px;padding:0px;">
    $content.find('[lj-type=layer]').each(function () {
      let $this = $(this)
      // let id = $this.attr('id')
      // if (id) {
      //   // console.log('id=', id)
      //   $this.removeAttr('id')
      //   $this.wrap(`<div id="${id}" style="position:absolute;margin:0px;padding:0px;"></div>`)
      // }
      $this.css({ 'left': '24.97%' })
      changeFitToDefault($this)
      // console.log(this)
    })
    $content.find('[lj-type=frame]').each(function () {
      let $this = $(this)
      changeFitToDefault($this)
      // console.log(this)
    })
  }
}

function proc ({ $content, $tplContent, buildInfo }) {
  return Promise.pipe([
    function () {
      return ProcElement($content, buildInfo)
    },
    function () {
      return ProcElement($tplContent, buildInfo)
    }])
}

export default proc
